<template>
  <a class="mr-2" @click="triggerHistory">
    <slot>
      <a variant="default" size="small">
        <span v-if="bulkAction">
          <MIcon name="check" class="action-menu-icon" />
          <span class="ml-1 action-menu-text">
            {{ $tc('approve') }}
          </span>
        </span>
        <span v-else>
          <MButton
            shape="circle"
            class="mr-1"
            variant="success"
            :disabled="item.status === 'rejected_pending'"
          >
            <MIcon name="check" />
          </MButton>
        </span>
      </a>
    </slot>
    <FlotoDrawer width="55%" :open="showDrawer" class="flex" @hide="hideDrawer">
      <template v-slot:title>
        {{ $tc('approve', 2) }}
      </template>
      <component
        :is="selectionComponent"
        :max-allowed-selection="1"
        selectable
        :module-name="selectedRelationType"
        :source-module-name="moduleName"
        searchable
        :fetch-fn="fetchEligableRelations"
        v-bind="$attrs"
        @selection-change="setSelectedItems"
        @ticket-sub-module-change="handleTicketSubModuleChange"
      />
      <template v-slot:actions="{ hide }">
        <MButton
          :disabled="selectedItems.length === 0 || selectedItems.length > 1"
          outline
          class="mr-2"
          :loading="processing"
          @click="handleAddRelations"
        >
          {{ $t('add') }}
        </MButton>
        <MButton variant="default" @click="hide">
          {{ $tc('cancel') }}
        </MButton>
      </template>
    </FlotoDrawer>
  </a>
</template>
<script>
// import { getEligableRelationApi } from '@components/relation/relation-api'
import { searchTicketsApi } from '@modules/ticket/ticket-api'
import { transformTicketForList } from '@data/ticket'
import TicketSelectionContainer from './ticket-selection-container'
import { VarianceApprovalApi } from '../../../asset-api'
export default {
  name: 'VarianceApprovalDrawer',
  components: { TicketSelectionContainer },
  props: {
    item: {
      type: [Object, Array],
      default: undefined,
    },
    variance: {
      type: Array,
      default: undefined,
    },
    resourceId: { type: Number, required: true },
    resource: { type: Object, required: true },
    bulkAction: { type: Boolean, defauult: false },
    selectedItemsId: { type: Array, default: undefined },
  },
  data() {
    return {
      processing: false,
      selectedItems: [],
      showDrawer: false,
      selectedTicketSubModuleName: null,
      selectedRelationType: this.$constants.REQUEST,
      moduleName: this.$constants.REQUEST,
    }
  },
  computed: {
    selectionComponent() {
      if (
        [this.$constants.REQUEST, this.$constants.CHANGE].indexOf(
          this.selectedRelationType
        ) >= 0
      ) {
        return TicketSelectionContainer
      }
      return 'template'
    },
  },
  methods: {
    handleAddRelations() {
      if (this.processing) {
        return
      }
      this.processing = true
      VarianceApprovalApi(
        this.selectedItemsId ? this.selectedItemsId : [this.item.id],
        this.resourceId,
        this.selectedTicketSubModuleName,
        // this.selectedItems.map(({ id }) => id)
        this.selectedItems[0].id
      )
        .then((data) => {
          this.$emit('refresh')
          this.hideDrawer()
        })
        .finally(() => {
          setTimeout(() => {
            this.processing = false
          }, 250)
        })
    },
    hideDrawer() {
      this.selectedRelationType = null
      this.selectedTicketSubModuleName = null
      this.selectedItems = []
      this.showDrawer = false
      this.$emit('refresh')
    },
    triggerHistory() {
      this.$emit('trigger')
      setTimeout(() => {
        this.showDrawer = true
      }, 400)
    },
    transformFn() {
      if (
        [this.$constants.REQUEST, this.$constants.PROBLEM].indexOf(
          this.selectedRelationType
        ) >= 0
      ) {
        return transformTicketForList
      }
      return (e) => e
    },
    fetchEligableRelations(targetModuleName, criterias, limit, offset) {
      return searchTicketsApi(
        targetModuleName || this.selectedRelationType,
        criterias,
        limit,
        offset
      ).then((data) => {
        return {
          ...data,
          items: data.items.map(this.transformFn()),
        }
      })
    },
    setSelectedItems(items) {
      this.selectedItems = items
    },
    handleTicketSubModuleChange(subModuleName) {
      this.selectedTicketSubModuleName = subModuleName
    },
  },
}
</script>
